// src/components/SkeletonLoader.js - NEW FILE
import React from 'react';
import '../styles/components/SkeletonLoader.css';

export const EventCardSkeleton = () => (
  <div className="event-card skeleton-card">
    <div className="event-image-wrapper">
      <div className="skeleton-image event-image"></div>
    </div>
    <div className="event-card-utility skeleton-card-utility">
      <div className="skeleton-text"></div>
      <div className="skeleton-text"></div>
    </div>
    <div className="event-card-body">
      <div className="skeleton-title"></div>
      <div className="skeleton-meta">
        <div className="skeleton-text"></div>
        <div className="skeleton-text short"></div>
      </div>
      <div className="skeleton-button"></div>
    </div>
  </div>
);

export const BlogCardSkeleton = () => (
  <div className="article-card skeleton-card">
    <div className="skeleton-image"></div>
    <div className="article-card-content">
      <div className="skeleton-text short"></div>
      <div className="skeleton-title"></div>
      <div className="skeleton-text"></div>
    </div>
  </div>
);

export const ToolCardSkeleton = () => (
  <div className="tool-card tool-card-skeleton">
    <div className="skeleton skeleton-icon" style={{ width: '50px', height: '50px', borderRadius: '12px' }}></div>
    <div className="tool-card-content" style={{ flex: 1 }}>
      <div className="skeleton skeleton-text" style={{ width: '80px', height: '20px', marginBottom: '0.75rem' }}></div>
      <div className="skeleton skeleton-text" style={{ width: '100%', height: '24px', marginBottom: '0.5rem' }}></div>
      <div className="skeleton skeleton-text" style={{ width: '100%', height: '60px', marginBottom: '1.5rem' }}></div>
      <div className="skeleton skeleton-text" style={{ width: '120px', height: '32px', borderRadius: '50px' }}></div>
    </div>
  </div>
);

export const TeamCardSkeleton = () => (
  <div className="team-card skeleton-card">
    <div className="skeleton-image" style={{ height: '400px' }}></div>
  </div>
);

export const ExperimentCardSkeleton = () => (
  <div className="experiment-card skeleton-card">
    <div className="skeleton-image" style={{ height: '250px' }}></div>
    <div className="experiment-card-content">
      <div className="skeleton-title"></div>
      <div className="skeleton-text"></div>
      <div className="skeleton-text short"></div>
    </div>
  </div>
);

export const BlogPostSkeleton = () => (
  <div className="blog-post-page">
    <section className="blog-post-hero">
      <div className="container">
        <div className="blog-post-hero-image skeleton-box" style={{ height: '400px', borderRadius: '12px' }}></div>
      </div>
    </section>

    <section className="blog-post-content-section py-5">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-12">
            <article className="blog-post-article">
              <div className="skeleton-title" style={{ height: '60px', width: '80%', marginBottom: '30px' }}></div>
              
              <div className="blog-post-meta mb-4">
                <div className="d-flex align-items-center gap-3">
                  <div className="skeleton-box" style={{ width: '50px', height: '50px', borderRadius: '50%' }}></div>
                  <div>
                    <div className="skeleton-text" style={{ width: '150px', marginBottom: '8px' }}></div>
                    <div className="skeleton-text" style={{ width: '120px' }}></div>
                  </div>
                </div>
              </div>

              <div className="skeleton-text" style={{ width: '200px', marginBottom: '30px' }}></div>

              <div className="share-section mb-4">
                <div className="skeleton-text" style={{ width: '150px', marginBottom: '15px' }}></div>
                <div className="d-flex gap-2">
                  {Array(5).fill(0).map((_, i) => (
                    <div key={i} className="skeleton-box" style={{ width: '40px', height: '40px', borderRadius: '50%' }}></div>
                  ))}
                </div>
              </div>

              <div className="blog-post-body">
                {Array(8).fill(0).map((_, i) => (
                  <div key={i} className="skeleton-text" style={{ marginBottom: '12px', width: i % 3 === 0 ? '90%' : '100%' }}></div>
                ))}
              </div>
            </article>
          </div>
        </div>
      </div>
    </section>
  </div>
);
